import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const SecuritiesAccount = React.lazy(() =>
    import('../SecuritiesAccount')
);
const securitiesAccountRoutesRegistry = [
    {
        path: PAGE_URL.SECURITIES_ACCOUNT_PAGE,
        element: <SecuritiesAccount />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default securitiesAccountRoutesRegistry;
